import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Routes } from 'react-scale/components/GrowthCenter/urls';
import { ResumeScreeningPage } from 'react-scale/components/GrowthCenter/ResumeScreening/GrowthCenterResumeScreening';
import EmailDripCampaignPage from 'react-scale/components/GrowthCenter/EmailDripCampaign/EmailDripCampaignPage';
import CampaignSetupPage from 'react-scale/components/GrowthCenter/EmailDripCampaign/CampaignSetup/CampaignSetupPage';
import { IUserJson } from '@scale/shared/types/user';
import ResumeScreeningJobPage from 'react-scale/components/GrowthCenter/ResumeScreening/ResumeScreeningJob/ResumeScreeningJobPage';
import ResumeScreenCreationOrUpdate from 'react-scale/components/GrowthCenter/ResumeScreening/ResumeScreenCreationOrUpdate';
import OnboardingFlowsPage from 'react-scale/components/GrowthCenter/OnboardingControlPanel/OnboardingFlowsPage';
import OnboardingFlowPage from 'react-scale/components/GrowthCenter/OnboardingControlPanel/OnboardingFlow/OnboardingFlowPage';
import { ToastContainer } from 'react-toastify';
import SmsSetup from './SMS/SmsSetup';
import SmsPage from './SMS/SmsPage';
import { useParams } from 'react-router';
import CommunicationsHistoryPage from 'react-scale/components/GrowthCenter/CommunicationsHistory/CommunicationsHistoryPage';
import TemplatesLibraryPage from 'react-scale/components/GrowthCenter/TemplatesLibrary/TemplatesLibraryPage';
import TemplateSetupPage from 'react-scale/components/GrowthCenter/TemplatesLibrary/TemplateSetupPage';
import JobPostPage from 'react-scale/components/GrowthCenter/JobPost/JobPostPage';
import JobPostSetupPage from 'react-scale/components/GrowthCenter/JobPost/JobPostSetupPage';
import { Routes as ScreeningCenterRoutes } from 'react-scale/components/ScreeningCenter/constants';

const EmailDripCampaignSetupRedirectWithCampaignId = () => {
  const { campaignId } = useParams<{ campaignId: string }>();
  return <Redirect to={`${Routes.CommunicationSetup}/${campaignId}`} />;
};
const FallbackRedirect = () => {
  const fullPath = window.location.pathname;

  useEffect(() => {
    if (!window.location.pathname.includes('/corp/growth-center')) {
      window.location.assign(fullPath);
    }
  }, [fullPath]);

  return null;
};

export const GrowthCenterContent: React.FC<{ user: IUserJson }> = ({ user }) => {
  return (
    <div className="h-full">
      <ToastContainer />
      <Switch>
        <Route exact path={Routes.ResumeScreening}>
          <ResumeScreeningPage />
        </Route>
        <Route exact path={Routes.OneOffResumeScreening}>
          <ResumeScreeningJobPage />
        </Route>
        <Route exact path={`${Routes.OneOffResumeScreening}/:jobId`}>
          <ResumeScreeningJobPage />
        </Route>
        <Route exact path={Routes.ResumeScreeningSetup}>
          <ResumeScreenCreationOrUpdate />
        </Route>
        <Route exact path={`${Routes.ResumeScreening}/:jobId`}>
          <ResumeScreenCreationOrUpdate />
        </Route>
        <Route exact path={Routes.EmailDripCampaign}>
          <Redirect to={Routes.Communication} />
        </Route>
        <Route exact path={Routes.EmailDripCampaignSetup}>
          <Redirect to={Routes.CommunicationSetup} />
        </Route>
        <Route exact path={`${Routes.EmailDripCampaignSetup}/:campaignId`}>
          <EmailDripCampaignSetupRedirectWithCampaignId />
        </Route>
        <Route exact path={Routes.Communication}>
          <EmailDripCampaignPage user={user} />
        </Route>
        <Route exact path={Routes.CommunicationSetup}>
          <CampaignSetupPage user={user} />
        </Route>
        <Route exact path={`${Routes.CommunicationSetup}/:campaignId`}>
          <CampaignSetupPage user={user} />
        </Route>
        <Route exact path={Routes.OnboardingControlPanel}>
          <OnboardingFlowsPage />
        </Route>
        <Route exact path={`${Routes.OnboardingControlPanel}/:flowId`}>
          <OnboardingFlowPage user={user} />
        </Route>
        <Route exact path={Routes.SmsSetup}>
          <SmsSetup />
        </Route>
        <Route path={'/growth-center/screening-center'}>
          <Redirect to={ScreeningCenterRoutes.ScreeningCenter} />
        </Route>
        <Route exact path={`${Routes.SmsSetup}/:smsCommunicationId`}>
          <SmsSetup />
        </Route>
        <Route exact path={Routes.Sms}>
          <SmsPage user={user} />
        </Route>
        <Route exact path={Routes.JobPost}>
          <JobPostPage />
        </Route>
        <Route exact path={Routes.JobPostSetup}>
          <JobPostSetupPage user={user} />
        </Route>
        <Route exact path={`${Routes.JobPostSetup}/:jobPostId`}>
          <JobPostSetupPage user={user} />
        </Route>
        <Route exact path={Routes.CommunicationsHistory}>
          <CommunicationsHistoryPage />
        </Route>
        <Route exact path={Routes.TemplatesLibrary}>
          <TemplatesLibraryPage />
        </Route>
        <Route exact path={[Routes.TemplateSetup, `${Routes.TemplateSetup}/:templateId`]}>
          <TemplateSetupPage />
        </Route>
        <Route path="*">
          <FallbackRedirect />
        </Route>
      </Switch>
    </div>
  );
};
